import { Component, inject } from '@angular/core';
import { ApiPetitionMissionRank, PetitionsApi } from '@tytapp/api';
import { HomeCard, HomeCardComponentType } from '@tytapp/app/pages/home-page/home-cards.service';
import { Shell } from '@tytapp/common';
import { WhatIsAMissionComponent } from '@tytapp/polls';
import { UserService } from '@tytapp/user';


@Component({
    selector: 'tyt-mission-leaderboard',
    templateUrl: './mission-leaderboard.component.html',
    styleUrls: [ './mission-leaderboard.component.scss' ]
})
export class MissionLeaderboardComponent implements HomeCardComponentType {
    private shell = inject(Shell);
    private userService = inject(UserService);
    private petitionsApi = inject(PetitionsApi);

    card: HomeCard;
    title = 'Mission Leaderboard';
    icon = { type: 'material', text: 'campaign' } as const;
    more = { url: '/campaigns', label: 'View All Petitions' }
    get hidden() { return this.entries?.length === 0; }

    entries: ApiPetitionMissionRank[];
    expectedCount = 6;
    state: 'loading' | 'ready' = 'loading';

    async ngOnInit() {
        this.entries = await this.petitionsApi.getMissionLeaderboard().toPromise();
        this.state = 'ready';
    }

    showDialog() {
        this.shell.showDialog(WhatIsAMissionComponent, !!this.userService.user);
    }
}
